import React from 'react';
import { Popover, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import AccordianTable from '../../../testRunInstanceDashboard/Components/AccordianTable';

const defaultProps = {
  userThresholds: [],
  disabled: false
};

const ActivityLogRiskIndiModel = ({ userThresholds, disabled }) => (
  <Popover
    content={<AccordianTable thresholds={userThresholds} />}
    autoAdjustOverflow={false}
    arrowPointAtCenter
    trigger={!disabled ? 'click' : 'none'}
    placement="bottomRight">
    <Button icon={<MoreOutlined background="#B8BEC5" />} disabled={disabled} />
  </Popover>
);

ActivityLogRiskIndiModel.defaultProps = defaultProps;

export default ActivityLogRiskIndiModel;
